import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-telehealth-payment',
    templateUrl: './dialog-telehealth-payment.component.html',
    styleUrls: ['./dialog-telehealth-payment.component.scss'],
    standalone: false
})
export class DialogTelehealthPaymentComponent {
  
  constructor(private dialogRef: MatDialogRef<DialogTelehealthPaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    
  }

  onNoClick() {
    this.dialogRef.close({ status: 'FAIL' })
  }
  onYesClick() {
    this.dialogRef.close({ status: 'SUCCESS' })
  }

}
